import script from "./ButtonSecondaryIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonSecondaryIcon.vue?vue&type=script&setup=true&lang=js"

import "./ButtonSecondaryIcon.vue?vue&type=style&index=0&id=2a546fce&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a546fce"]])

export default __exports__